import { COLORS } from '@/constants';
import { Modal, Tabs } from '@mui/material';
import styled from 'styled-components';
import { Swiper } from 'swiper/react';
import noImage from '@/assets/webp/no-image.webp';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;

  @media (max-width: 1280px) {
    gap: 12px;
  }

  @media (max-width: 920px) {
    flex-direction: column;
  }
`;
export const BigImagesBox = styled.div`
  height: 423px;
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  background: #eeeeee url('${noImage.src}') center / cover no-repeat;
`;
export const SmallImagesBox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 24px;
  height: 423px;
  width: 100%;
  flex: 1;

  @media (max-width: 1280px) {
    gap: 12px;
  }

  @media (max-width: 920px) {
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 1fr;
    height: 200px;
  }
`;

export const ImageWrapper = styled.div<{ $maxHeight?: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  max-height: ${({ $maxHeight }) => ($maxHeight ? $maxHeight : 'auto')};
  background: #eeeeee url('${noImage.src}') center / cover no-repeat;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
  }

  @media (max-width: 1280px) {
    max-height: ${({ $maxHeight }) => ($maxHeight ? '206px' : 'auto')};
  }
  @media (max-width: 920px) {
    max-height: none;
  }
`;

export const ImageButton = styled.button`
  position: absolute;
  background: #37446937;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const PlayIconBox = styled.div`
  width: 70px;
  height: 70px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;

    path {
      transitions: 0.2;
    }
  }

  &:hover {
    path {
      fill: ${COLORS.orange};
    }
  }
`;

export const MoreMediaBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 12px;
  border-radius: 6px;
  color: ${COLORS['primary/800']};
  background: ${COLORS.white};
  cursor: pointer;
  margin: 10px;

  svg {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  &:hover {
    background: ${COLORS.orange};
    color: ${COLORS.white};
    path {
      fill: ${COLORS.white};
    }
  }
`;

export const ModalContent = styled.div`
  width: 935px;
  max-width: 90vw;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding: 20px 24px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 22px;

  &:focus {
    outline: none !important;
  }
`;

export const ModalHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PhotoDetailModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1400;
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const MainSwiper = styled(Swiper)`
  flex: 1;
  width: 100%;

  .swiper-pagination {
    display: none;
  }

  .custom-prev,
  .custom-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    border: none;
    width: 60px;
    height: 60px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;

    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #151b2850 !important;

    color: white;
    font-size: 52px;
  }

  .custom-prev span,
  .custom-next span {
    display: block;
    width: fit-content;
  }

  .custom-prev:hover,
  .custom-next:hover,
  .custom-pagination:hover {
    background: #151b2870 !important;
  }

  .custom-prev.swiper-button-disabled,
  .custom-next.swiper-button-disabled {
    display: none;
  }

  .custom-prev {
    left: 14px;
  }
  .custom-next {
    right: 14px;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const SwiperSlideWrapper = styled.div`
  width: 100%;
  height: 60vh;
  max-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: 720px) {
    height: 40vh;
    border-radius: 6px;
  }
`;

export const PhotoDetailImage = styled.img`
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  max-height: 80vh;
  object-fit: contain;
`;

export const ThumbsSwiper = styled(Swiper)`
  height: 100px;
  max-width: 90vw;
  width: 1220px;
  padding: 20px 0;

  .swiper-slide {
    height: 70px;
    opacity: 0.4;
    transition: opacity 0.3s;

    &-thumb-active {
      opacity: 1;
    }
  }
`;

export const ThumbImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  background: #eeeeee url('${noImage.src}') center / contain no-repeat;
`;

export const YouTubeSwiper = styled(Swiper)`
  height: 467px;
  max-width: 100%;

  .custom-prev,
  .custom-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;

    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #151b2850 !important;

    color: white;
    font-size: 26px;
  }

  .custom-prev span,
  .custom-next span {
    display: block;
    width: fit-content;
  }

  .custom-prev:hover,
  .custom-next:hover,
  .custom-pagination:hover {
    background: #151b2870 !important;
  }

  .custom-prev.swiper-button-disabled,
  .custom-next.swiper-button-disabled {
    display: none;
  }

  .custom-prev {
    left: 14px;
  }
  .custom-next {
    right: 14px;
  }

  width: 100%;
  height: 100%;
`;

export const Tour360Btn = styled.button`
  position: absolute;
  bottom: 0;
  right: 20px;
  padding: 6px;
  cursor: pointer;
  background: ${COLORS['neutral/50']};
  border: 1px solid transparent;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  width: 40px;
  height: 40px;

  svg {
    width: 24px;
    height: 24px;
    object-fit: contain;
    object-position: center;
  }
`;

export const SafePhotoSphereBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTabs = styled(Tabs)`
  && {
    .MuiTab-root {
      text-transform: none;
      border-bottom: 2px solid transparent;
      height: 40px;
      transition: all 0.2s ease-in-out;
    }
    .Mui-selected {
      color: ${COLORS['secondary/500']} !important;
      border-bottom: 2px solid ${COLORS['secondary/500']};
    }
    .MuiTabs-indicator {
      display: none;
    }
  }
`;

export const Tour360ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 24px;
  border-radius: 8px;
  padding: 20px 24px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  width: min(1200px, 95vw);
  background: #fff;
`;

export const Tour360ModalBox = styled.div`
  flex: 1;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  min-height: 500px;
  overflow: hidden;
`;

export const Tour360IframeBox = styled.div`
  width: 100%;
  text-align: center;
  flex: 1;
`;

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotFoundBox = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const Tour360Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  min-height: 500px;
`;

export const YouTubeBox = styled.div`
  height: 467px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
`;

export const YouTubeContainer = styled.div`
  height: fit-content;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
`;

export const ShowMoreControlsBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: column;
`;
